import { types } from 'mobx-state-tree'

const FileUploadItems = types.model('FileUploadItems', {
  fileUploadScheduleId: types.maybeNull(types.number),
  fileLength: types.maybeNull(types.number)
})

export type IFileUploadItems = typeof FileUploadItems.Type
export default FileUploadItems
